import { NgxSpinnerService } from "ngx-spinner";
import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { Router } from "@angular/router";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";

import { Funcionalidade } from "../../models/Funcionalidade.model";
import { FuncionalidadeInterface } from "../../contracts/Funcionalidade.interface";
import { ApiService } from "../../services/api.service";
import { PermissionsService } from "src/app/helpers/permissions.service";
import { Page } from "src/app/utils/paginate";
import { ApiBaseService } from "src/app/services/migrate/api.base.service";
import storageX from "src/app/storageCore/storageX";
import { STORAGE_KEY_CURRENT_USER } from "src/app/storageCore/constStorageKeys";
@Component({
  selector: "app-funcionalidade",
  templateUrl: "./funcionalidade.component.html",
  styleUrls: ["./funcionalidade.component.scss"],
})
export class FuncionalidadeComponent implements OnInit, AfterViewInit {
  permissions: [];

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  //@ViewChild('filter') filter: ElementRef;
  //@ViewChild('typeFilter') typeFilter: ElementRef;
  public filter;
  public typeFilter;

  public page = new Page();
  public errorMessage;
  public loader = false;
  public length = 0;
  public pageSize = 10;
  public totalElements = 0;
  public totalPages = 0;

  public displayedColumns: string[] = [
    //'id', OCULTADO CAMPO ID DA TABELA - 20102020 - MARCOS TAVARES
    "nmFuncionalidade",
    "dsFuncionalidade",
    "update",
    "clone",
    "view",
    "delete",
  ];

  public filtros = [
    //{ campo: 'id', valor: 'ID' },
    { campo: "nmFuncionalidade", valor: "Nome Funcionalidade" },
    { campo: "dsFuncionalidade", valor: "Descrição Funcionalidade" },
  ];

  private service: ApiService;
  private apiBaseService: ApiBaseService;

  public funcionalidade: MatTableDataSource<FuncionalidadeInterface>;

  constructor(
    apiBaseService: ApiBaseService,
    private spinner: NgxSpinnerService,
    apiService: ApiService,
    public router: Router,
    public permissionService: PermissionsService
  ) {
    this.apiBaseService = apiBaseService;
    this.service = apiService;

    this.funcionalidade = new MatTableDataSource<FuncionalidadeInterface>([]);
  }

  ngOnInit(): void {
    this.loadFuncionalidade();
  }
  //public handleFilter = (value: string): void => {
  //this.funcionalidade.filter = value.trim().toLocaleLowerCase();
  //};

  public handleSort = (sort): void => {
    this.loadFuncionalidade(0, sort);
  };

  public handlePageChanged = (value): void => {
    const { pageIndex } = value;
    this.loadFuncionalidade(pageIndex);
  };
  public handleFilter = (): void => {
    this.loadFuncionalidade();
  };
  public handleDelete = (id: string): void => {
    this.deleteFuncionalidade(id);
  };

  public handleUpdate = (id): void => {
    this.router.navigate([`/funcionalidade/${id}`]);
  };

  ngAfterViewInit(): void {
    this.funcionalidade.sort = this.sort;
    this.funcionalidade.paginator = this.paginator;
  }

  public async deleteFuncionalidade(id): Promise<void> {
    const idUsuario = storageX.whereKeyIs(STORAGE_KEY_CURRENT_USER).get()?.id;
    if (confirm("Tem certeza que deseja deletar esse registro?")) {
      try {
        this.spinner.show();

        await this.apiBaseService.delete<Funcionalidade>(
          idUsuario,
          id,
          new Funcionalidade()["nomeConsultaApiBase"]
        );

        this.spinner.hide();

        this.loadFuncionalidade();
      } catch (error) {
        this.spinner.hide();
        this.errorMessage = error.message;
        throw new EvalError(error);
      }
    }
  }

  public async loadFuncionalidade(pageIndex = 0, sort?): Promise<void> {
    const params = {
      size: this.pageSize,
      page: pageIndex,
    };

    try {
      this.spinner.show();

      const result = await this.apiBaseService.get<any>({
        url: new Funcionalidade()["nomeConsultaApiBase"],
        params,
      });

      this.funcionalidade.data = result["content"];
      this.page = result["page"];

      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      this.errorMessage = error.message;
      throw new EvalError(error);
    }
  }
}
